import { ProjectService, ThemeService } from "@wms/services";
import { inject, Injectable } from "@angular/core";
import { isResolveConflictsExists } from "@wm/core";
import { PrefabManager } from "@wms/page-workspace";
import { WmxWidgetsManager } from "@wms/app/workspace/page-workspace/wmxwidgets/wmxwidgets-manager";
import { WmsWorkspaceManagerService } from "@wms/app/workspace";
import { Router } from '@angular/router'
import { groupBy } from 'lodash-es'
import { VcsService } from "@wms/app/vcs/services/vcs.service";
import { MyWidgetsManager } from "@wms/app/workspace/page-workspace/mywidgets/mywidgets-manager";
@Injectable({
  providedIn: 'root'
})
export class StudioFactory {
  private projectService: ProjectService;
  public actionsResponse: any;
  public hasMergeChangesConflicts: boolean = false
  public showApplyMergeChangesWS: boolean = false
  private router: Router;
  private vcsService: VcsService
  constructor(private prefabManager: PrefabManager, private workspaceManager: WmsWorkspaceManagerService, private myWidgetsManager : MyWidgetsManager, private wmxWidgetsManager : WmxWidgetsManager, private themeService: ThemeService) {
    this.projectService = inject(ProjectService);
    this.router = inject(Router);
    this.vcsService = inject(VcsService)
    this.themeService = inject(ThemeService);
  }

  init() {
    let projectDetails = this.projectService.getDetails();
    //If there are any conflicts in the project, first they must be resolved before getting prefabs
    if (projectDetails && projectDetails.mergeInProgress) {
      this.showApplyMergeChangesWS = true
      this.workspaceManager.setActiveWSCategory("MERGECHANGES");
      this.router.navigate(['mergechanges']);
    } else {
      //gets the prefabs in the workspace
      this.prefabManager.fetchWorkspacePrefabs()
        .then(() => {
          this.prefabManager.fetchProjectPrefabs()
            .then(() => {
              this.prefabManager.loadPrefabs()
              this.prefabManager.addBundledPrefabsToWorkspace()
                .then(() => {
                  this.prefabManager.setVersionMismatchMessages();
                  // ThemeManager.loadThemes($scope, function () {
                  //   ThemeManager.getProjectThemeList(project.id, $scope, function () {
                  //     $rootScope.$emit('wms:init'); // hides the project loader
                  //   });
                  // });
                })
            });
        });
      this.myWidgetsManager.processWidgetsForDisplay();
      if(this.projectService.isMobileApplicationType()){
        if(this.projectService.isPrism()) {
          this.themeService.loadMobileFoundationTheme();
        }
        this.wmxWidgetsManager.getWMXComponents();
      }
    }
  }
}
